import {
  MobileOutlined,
  SafetyOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import BadgeIcon from "../assets/images/vectors/BadgeIcon";
import CredentialInvitationIcon from "../assets/images/vectors/CredentialInvitationIcon";
import DWIcon from "../assets/images/vectors/DWIcon";
import FarpointeMobileIcon from "../assets/images/vectors/FarpointeMobileIcon";
import GeminiIcon from "../assets/images/vectors/GeminiIcon";
import LogApiIcon from "../assets/images/vectors/LogApiIcon";
import MobileAppIcon from "../assets/images/vectors/MobileAppIcon";
import RestApiIcon from "../assets/images/vectors/RestApiIcon";
import SicunetMobileIcon from "../assets/images/vectors/SicunetMobileIcon";
import SpecoIcon from "../assets/images/vectors/SpecoIcon";
import SSOIcon from "../assets/images/vectors/SSOIcon";
import ThumbDriveIcon from "../assets/images/vectors/ThumbDriveIcon";
import VisitorInvitationIcon from "../assets/images/vectors/VisitorInvitationIcon";
import VitekIcon from "../assets/images/vectors/VitekIcon";
import WavelynxMobileIcon from "../assets/images/vectors/WavelynxMobileIcon";
import LocksetIcon from "../assets/images/vectors/LocksetIcon";
import TrilogyIcon from "../assets/images/vectors/TrilogyIcon";
import FacegateIcon from "../assets/images/vectors/FacegateIcon";
import OSDPIcon from "../assets/images/vectors/OSDPIcon";
import DirectoryIcon from "../assets/images/vectors/DirectoryIcon";
import IntercomIcon from "../assets/images/vectors/IntercomIcon";
import LicenseTypeIcon from "../assets/images/vectors/LicenseTypeIcon";
import SiteTypeIcon from "../assets/images/vectors/SiteTypeIcon";
import ProductIcon from "../assets/images/vectors/ProductIcon";

export const siteTypeOptions = [
  {
    value: 0,
    label: "On Premise",
  },
  {
    value: 1,
    label: "RMC",
  },
  {
    value: 2,
    label: "RMC Plus",
  },
  {
    value: 3,
    label: "Cloud",
  },
  {
    value: 4,
    label: "Virtual",
  },
];
export const booleanOptions = [
  {
    value: 1,
    label: "Yes",
  },
  {
    value: 0,
    label: "No",
  },
];
export const nodeTypeOptions = [
  {
    value: 1,
    label: "Server Node",
  },
  {
    value: 2,
    label: "Client Node",
  },
];
export const productOptions = [
  {
    value: 0,
    label: "0 Door",
  },
  {
    value: 1,
    label: "1 Door",
  },
  {
    value: 2,
    label: "2 Door",
  },
  {
    value: 4,
    label: "4 Door",
  },
  {
    value: 8,
    label: "8 Door",
  },
];
export const modelOptions = [
  {
    value: 0,
    label: "Advantage",
  },
  {
    value: 1,
    label: "Professional",
  },
  {
    value: 2,
    label: "Corporate",
  },
];

export const licenseOptions = [
  {
    value: 1,
    label: "REST API",
  },
  {
    value: 2,
    label: "Log API",
  },
  {
    value: 3,
    label: "Gemini",
  },
  {
    value: 4,
    label: "Mobile App",
  },
  {
    value: 5,
    label: "Credential Invitation",
  },
  {
    value: 6,
    label: "Visitor Invitation",
  },
  {
    value: 7,
    label: "Single Sign On",
  },
  {
    value: 8,
    label: "Badge",
  },
  {
    value: 33,
    label: "Thumb Drive NVR",
  },
  {
    value: 34,
    label: "DW Spectrum",
  },
  {
    value: 35,
    label: "Speco NVR",
  },
  {
    value: 36,
    label: "Vitek NVR",
  },
  {
    value: 41,
    label: "Sicunet Mobile",
  },
  {
    value: 42,
    label: "Wavelynx Mobile",
  },
  {
    value: 43,
    label: "Farpointe Mobile",
  },
  {
    value: 64,
    label: "Expired",
  },
];
export const deviceOptions = [
  {
    value: 193,
    label: "Channel",
  },
  {
    value: 194,
    label: "Lockset",
  },
  {
    value: 195,
    label: "Facegate",
  },
  {
    value: 196,
    label: "OSDP Device",
  },
  {
    value: 197,
    label: "Trilogy Lockset",
  },
  {
    value: 198,
    label: "Intercom",
  },
  {
    value: 199,
    label: "Directory",
  },
  {
    value: 200,
    label: "Invitation",
  },
];
export const itemOptions = [
  {
    value: 1,
    label: "Site Type",
  },
  {
    value: 2,
    label: "Model",
  },
  {
    value: 3,
    label: "Door",
  },
  {
    value: 101,
    label: "Rest API",
  },
  {
    value: 102,
    label: "Log API",
  },
  {
    value: 103,
    label: "Gemini",
  },
  {
    value: 104,
    label: "Mobile App",
  },
  {
    value: 105,
    label: "Credential Invitation",
  },
  {
    value: 106,
    label: "Visitor Invitation",
  },
  {
    value: 107,
    label: "Single Sign On",
  },
  {
    value: 108,
    label: "Badge",
  },
  {
    value: 202,
    label: "Channel",
  },
  {
    value: 203,
    label: "Lockset",
  },
  {
    value: 204,
    label: "Facegate",
  },
  {
    value: 205,
    label: "OSDP Device",
  },
  {
    value: 206,
    label: "Trilogy Lockset",
  },
  {
    value: 207,
    label: "Intercom",
  },
  {
    value: 208,
    label: "Directory",
  },
  {
    value: 209,
    label: "Mobile Credential",
  },
];

export const findOptionLabel = (options, value) => {
  const matchedOption = options.find((item) => item.value === Number(value));
  if (matchedOption) {
    return matchedOption?.label;
  } else {
    return null;
  }
};

export const orderTypeOptions = [
  { label: "Annual", value: 0 },
  { label: "Lifetime", value: 1 },
];

export const doorpricingTiers = [
  { max: 4, code: 4 },
  { max: 8, code: 8 },
  { max: 16, code: 16 },
  { max: 32, code: 32 },
  { max: 64, code: 64 },
  { max: 128, code: 128 },
  { max: 255, code: 256 },
  { max: 512, code: 512 },
  { max: 1024, code: 1024 },
  { max: 65535, code: 65535 },
];

export const pricingTiers = {
  202: [
    // Channel
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  203: [
    // Lockset
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  208: [
    // Directory Extension
    { max: 400, code: 4 },
    { max: 800, code: 8 },
    { max: 1600, code: 16 },
    { max: 3200, code: 32 },
    { max: 6400, code: 64 },
    { max: 12800, code: 128 },
    { max: 25500, code: 255 },
  ],
  209: [
    // Mobile Credential
    { max: 400, code: 4 },
    { max: 800, code: 8 },
    { max: 1600, code: 16 },
    { max: 3200, code: 32 },
    { max: 6400, code: 64 },
    { max: 12800, code: 128 },
    { max: 25500, code: 255 },
  ],
  204: [
    // Facegate
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  205: [
    // OSDP Device
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  206: [
    // Trilogy Lockset
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
  207: [
    // Intercom
    { max: 4, code: 4 },
    { max: 8, code: 8 },
    { max: 16, code: 16 },
    { max: 32, code: 32 },
    { max: 64, code: 64 },
    { max: 128, code: 128 },
    { max: 255, code: 255 },
  ],
};

export const toggleCardOptions = [
  { value: 1, name: "Site Type" },
  { value: 2, name: "Model" },
  { value: 3, name: "Door" },
  { value: 101, name: "REST API" },
  { value: 102, name: "Log API" },
  { value: 103, name: "Gemini" },
  { value: 104, name: "Mobile App" },
  { value: 105, name: "Credential Invitation" },
  { value: 106, name: "Visitor Invitation" },
  { value: 107, name: "Single Sign On" },
  { value: 108, name: "Badge" },
];

export const inputCardOptions = [
  {
    label: "Channel",
    fieldName: "Channel",
    itemNo: 202, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Lockset",
    fieldName: "Lockset",
    itemNo: 203, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Facegate",
    fieldName: "Facegate",
    itemNo: 204, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "OSDP Device",
    fieldName: "Subnode",
    itemNo: 205, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },

  {
    label: "Trilogy Lockset",
    fieldName: "ContLock",
    itemNo: 206, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Intercom",
    fieldName: "Intercom",
    itemNo: 207, // Add this
    defaultValue: 0,
    max: 255,
    min: 0,
    step: 1,
    prefix: "$",
  },
  {
    label: "Directory Extension",
    fieldName: "Sicucom",
    itemNo: 208, // Add this
    defaultValue: 0,
    max: 25500,
    min: 0,
    step: 100,
    prefix: "$",
  },
  {
    label: "Mobile Credential",
    fieldName: "Invitation",
    itemNo: 209, // Add this
    defaultValue: 0,
    max: 25500,
    min: 0,
    step: 100,
    prefix: "$",
  },
];

// Icon mapping for different option types
export const iconMap = {
  "REST API": <RestApiIcon />,
  "Log API": <LogApiIcon />,
  Gemini: <GeminiIcon />,
  "Mobile App": <MobileAppIcon />,
  "Credential Invitation": <CredentialInvitationIcon />,
  "Visitor Invitation": <VisitorInvitationIcon />,
  "Single Sign On": <SSOIcon />,
  Badge: <BadgeIcon />,
  "Thumb Drive NVR": <ThumbDriveIcon />,
  "DW Spectrum": <DWIcon />,
  "Speco NVR": <SpecoIcon />,
  "Vitek NVR": <VitekIcon />,
  "Sicunet Mobile": <SicunetMobileIcon />,
  "Wavelynx Mobile": <WavelynxMobileIcon />,
  "Farpointe Mobile": <FarpointeMobileIcon />,
  Expired: <SafetyOutlined style={{ fontSize: "18px" }} />,
  // Input card icons (can be customized)
  Channel: <VideoCameraOutlined style={{ fontSize: "18px" }} />,
  Lockset: <LocksetIcon />,
  "ALLEGION Lockset": <SafetyOutlined style={{ fontSize: "18px" }} />,
  "Trilogy Lockset": <TrilogyIcon />,
  Facegate: <FacegateIcon />,
  "OSDP Device": <OSDPIcon />,
  Intercom: <IntercomIcon />,
  "Directory Extension": <DirectoryIcon />,
  "Mobile Credential": <MobileOutlined style={{ fontSize: "18px" }} />,
};

export const modelIconMap = {
  0: <LicenseTypeIcon />,
  1: <LicenseTypeIcon />,
  2: <LicenseTypeIcon />,
};

export const siteTypeIconMap = {
  0: <SiteTypeIcon />,
  1: <SiteTypeIcon />,
  2: <SiteTypeIcon />,
  3: <SiteTypeIcon />,
  4: <SiteTypeIcon />,
};
export const productIconMap = {
  0: <ProductIcon />,
  1: <ProductIcon />,
  2: <ProductIcon />,
  4: <ProductIcon />,
  8: <ProductIcon />,
};

export const hidePriceLabels = [
  "Sicunet Mobile",
  "Wavelynx Mobile",
  "Farpointe Mobile",
  "Vitek NVR",
  "Speco NVR",
  "DW Spectrum",
  "Thumb Drive NVR",
];

export const calculateTotals = (
  licenseOptionsData,
  licenseTypePrice,
  doorPrice,
  siteTypePrice = 0,
) => {
  let optionsTotal = 0;
  Object.entries(licenseOptionsData).forEach(([key, val]) => {
    if (!hidePriceLabels.includes(key)) {
      optionsTotal += val.price || 0;
    }
  });

  const total = licenseTypePrice + doorPrice + optionsTotal + siteTypePrice;
  return total.toFixed(2);
};

export const getItemNoByLabel = (label) => {
  // First check in toggleCardOptions
  const toggleOption = toggleCardOptions.find((item) => item.name === label);
  if (toggleOption) return toggleOption.value;
  const inputOption = inputCardOptions.find((item) => item.label === label);
  if (inputOption) return inputOption.itemNo;

  return null;
};

/**
 * Resolve gift card row (Item + CodeName/Code) to the value to send to backend.
 * Uses codesData first, then falls back to Common option lists (siteTypeOptions, modelOptions, productOptions).
 */
export const getCodeValueForGiftCard = (itemNo, codeName, code, codesData) => {
  if (codesData?.data) {
    let codeItem = codesData.data.find(
      (item) => item.Item === itemNo && item.CodeName === codeName,
    );
    if (!codeItem) {
      codeItem = codesData.data.find(
        (item) => item.Item === itemNo && item.Code === code,
      );
    }
    if (codeItem != null) return codeItem.Code;
  }
  if (itemNo === 1) {
    const opt = siteTypeOptions.find((o) => o.label === codeName);
    return opt != null ? opt.value : code;
  }
  if (itemNo === 2) {
    const opt = modelOptions.find((o) => o.label === codeName);
    return opt != null ? opt.value : code;
  }
  if (itemNo === 3) {
    const opt = productOptions.find((o) => o.label === codeName);
    return opt != null ? opt.value : code;
  }
  return code;
};

export const getPriceByItemNo = (itemNo, tierCode, codesData, type) => {
  if (!codesData?.data) {
    return 0;
  }

  let codeItem;

  if (tierCode) {
    // First, try to find with constructed codeName: "Door-4", "Channel-8", etc.
    const baseItem = codesData.data.find((item) => item.Item === itemNo);

    if (baseItem) {
      const constructedCodeName = `${baseItem.CodeName}-${tierCode}`;

      codeItem = codesData.data.find(
        (item) => item.Item === itemNo && item.CodeName === constructedCodeName,
      );
    }

    // If not found with constructed name, try matching by Item and Code directly
    if (!codeItem) {
      codeItem = codesData.data.find(
        (item) => item.Item === itemNo && item.Code === tierCode,
      );
    }
  } else {
    // For non-tiered items (toggles), just match by Item
    codeItem = codesData.data.find((item) => item.Item === itemNo);
  }

  if (!codeItem) {
    return 0;
  }

  const price =
    type === 0 ? parseFloat(codeItem.Annual) : parseFloat(codeItem.Lifetime);

  return price || 0;
};

export const getPrice = (
  itemLabel,
  codesData,
  type,
  quantity = 1,
  itemNo = null,
) => {
  // Get itemNo if not provided
  if (!itemNo) {
    itemNo = getItemNoByLabel(itemLabel);
  }

  // Use itemNo as lookup key
  const lookupKey = itemNo || itemLabel;

  if (pricingTiers[lookupKey]) {
    const tiers = pricingTiers[lookupKey];
    let totalPrice = 0;
    let remainingQuantity = quantity;
    let previousMax = 0;

    // Check if this is a divided-by-100 item using itemNo
    const isDividedBy100 = itemNo === 208 || itemNo === 209;

    for (const tier of tiers) {
      if (remainingQuantity <= 0) break;

      const tierCapacity = tier.max - previousMax;
      const unitsInThisTier = Math.min(remainingQuantity, tierCapacity);

      // Pass itemNo and tier.code (not tier.codeName)
      const tierPrice = getPriceByItemNo(itemNo, tier.code, codesData, type);

      if (isDividedBy100) {
        totalPrice += (unitsInThisTier / 100) * tierPrice;
      } else {
        totalPrice += unitsInThisTier * tierPrice;
      }

      remainingQuantity -= unitsInThisTier;
      previousMax = tier.max;
    }

    return totalPrice;
  } else {
    // For non-tiered items (like toggles), just pass the itemNo without tier code
    return getPriceByItemNo(itemNo, null, codesData, type);
  }
};

export const calculateLicenseTypePrice = (
  modelValue,
  licenseType,
  codesData,
  modifiedModelsOptions,
) => {
  if (!codesData?.data) return 0;

  // Find the model name from modifiedModelsOptions
  const selectedModel = modifiedModelsOptions.find(
    (model) => model.value === modelValue,
  );

  if (!selectedModel) return 0;

  // Map model labels to CodeName
  const modelCodeNameMap = {
    Advantage: "Advantage",
    Professional: "Professional",
    Corporate: "Corporate",
  };

  const codeName = modelCodeNameMap[selectedModel.label];
  if (!codeName) return 0;

  // Find the code item
  const codeItem = codesData.data.find((item) => item.CodeName === codeName);

  if (!codeItem) return 0;

  // Get price based on license type (0 = Annual, 1 = Lifetime)
  const price =
    licenseType === 0
      ? parseFloat(codeItem.Annual)
      : parseFloat(codeItem.Lifetime);

  return price;
};

export const calculateSiteTypePrice = (
  siteTypeValue,
  licenseType,
  codesData,
) => {
  if (!codesData?.data) return 0;

  // Map site type values to CodeName
  const siteTypeCodeNameMap = {
    0: "On Premise",
    1: "RMC",
    2: "RMC PLUS",
    3: "Cloud",
    4: "Virtual",
  };

  const codeName = siteTypeCodeNameMap[siteTypeValue];
  if (!codeName) return 0;

  // Find the code item with Item: 1 and matching CodeName
  const codeItem = codesData.data.find(
    (item) => item.Item === 1 && item.CodeName === codeName,
  );

  if (!codeItem) return 0;

  // Get price based on license type (0 = Annual, 1 = Lifetime)
  const price =
    licenseType === 0
      ? parseFloat(codeItem.Annual)
      : parseFloat(codeItem.Lifetime);

  return price || 0;
};

export const calculateDoorPrice = (doorCount, licenseType, codesData) => {
  if (!doorCount || doorCount <= 0) return 0;
  if (!codesData?.data) return 0;

  const DOOR_ITEM_NO = 3;
  let totalPrice = 0;
  let remainingDoors = Number(doorCount);
  let previousMax = 0;

  for (const tier of doorpricingTiers) {
    if (remainingDoors <= 0) break;

    const tierCapacity = tier.max - previousMax;
    const doorsInThisTier = Math.min(remainingDoors, tierCapacity);

    // Use getPriceByItemNo with itemNo=3 and the tier code
    const tierPrice = getPriceByItemNo(
      DOOR_ITEM_NO, // itemNo = 3
      tier.code, // code = 4, 8, 16, etc.
      codesData,
      licenseType,
    );

    totalPrice += doorsInThisTier * tierPrice;

    remainingDoors -= doorsInThisTier;
    previousMax = tier.max;
  }

  return totalPrice;
};
